import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
// import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { ImageService } from './image.service';
import { IconService } from './icon.service';
import { NgForageModule } from 'ngforage';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    // HttpModule,
    NgForageModule,
  ],
  declarations: [],
  providers: [
    ConstantsService,
    ImageService,
    IconService,
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    // Throw an error when core module is imported more than once
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts